import request from '@/utils/request'
// 查询维修区域列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/point/page',
        method: 'get',
        params: query,
    })
}
// 查询维修区域列表不分页
export function regionList(query) {
    return request({
        url: '/system/region/list',
        method: 'get',
        params: query,
    })
}
// 点位查询
export function pointList(query) {
    return request({
        url: '/upkeep/point/list',
        method: 'get',
        params: query,
    })
}
// 查询维修区域详细
export function getObj(id) {
    return request({
        url: '/upkeep/point/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修区域
export function addObj(data) {
    return request({
        url: '/upkeep/point/add',
        method: 'post',
        data: data,
    })
}

// 修改维修区域
export function putObj(data) {
    return request({
        url: '/upkeep/point/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修区域
export function delObj(data) {
    return request({
        url: '/upkeep/point/delete',
        method: 'post',
        data: data,
    })
}
export function delObjAll(data) {
    return request({
        url: '/upkeep/point/delete',
        method: 'post',
        data: data,
    })
}
